var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4254 23.7215C18.6088 23.5294 18.5389 23.2849 18.2857 23.2849H16.4957L19.7044 16.9288C19.8091 16.7367 19.7305 16.5882 19.5384 16.5882H15.7613C15.5081 16.5882 15.4208 16.6755 15.3422 16.8589L13.6841 24.2716C13.5881 24.4899 13.6841 24.6209 13.9112 24.6209H15.4305L14.2342 27.5198C14.1906 27.6333 14.2168 27.7293 14.2953 27.7642C14.3739 27.7992 14.47 27.773 14.566 27.6769L18.4254 23.7215Z",
    fill: "url(#paint0_linear_10214_592)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.555H10.186C7.60386 22.555 6.11768 20.9027 6.11768 18.8603C6.11768 17.0918 7.23854 15.6969 8.89909 15.2237C9.18969 11.9109 11.913 9.41176 15.1344 9.41176C17.6004 9.41176 19.6262 10.7485 20.7305 12.9404C23.7444 12.9404 25.9612 14.9995 25.9612 17.7311C25.9612 20.4378 23.7942 22.555 20.9962 22.555Z",
    fill: "#9CCAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1723 13.2216L20.3455 13.5654H20.7305C23.4495 13.5654 25.3362 15.3929 25.3362 17.7311C25.3362 20.0767 23.4651 21.93 20.9962 21.93H10.186C9.03131 21.93 8.17783 21.5632 7.61699 21.0233C7.05544 20.4827 6.74268 19.7266 6.74268 18.8603C6.74268 17.3845 7.6651 16.2252 9.07039 15.8247L9.48411 15.7068L9.5217 15.2783C9.7846 12.2812 12.2441 10.0368 15.1344 10.0368C17.3488 10.0368 19.1671 11.2263 20.1723 13.2216Z",
    stroke: "url(#paint1_linear_10214_592)",
    strokeOpacity: 0.4,
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_592",
    x: -13.8823,
    y: -10.5882,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_592",
    x1: 19.751,
    y1: 16.5882,
    x2: 10.3423,
    y2: 21.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_592",
    x1: 8,
    y1: 11,
    x2: 26,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38873,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5197F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11D);
export default __webpack_public_path__ + "static/media/11d.8f46a8c0258d6d36e47d654cc31fcada.svg";
export { ForwardRef as ReactComponent };